import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { timecardFeatureKey, timecardReducer } from './timecard.reducer';
import { TimecardEffects } from './timecard.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(timecardFeatureKey, timecardReducer),
        EffectsModule.forFeature([TimecardEffects])
    ]
})
export class TimecardStoreModule {}
